<markant-dialog
  #markantDialog
  class="container"
  style="text-align: center; width: 600px; height: 400px; padding: 0 !important"
  fullwidth="false"
  critical="true"
  open="true"
  (close)="this.dialogClosed()"
>
  <div class="markant-dialog">
    <div class="markant-dialog-header">
      <div class="markant-dialog-title"></div>
    </div>
    <div class="markant-dialog-content"></div>
    <div *ngIf="(this.transmittedImage || this.imageURL) && !isCoverImage()" id="testcontainer">
      <app-image-editor
        [width]="width"
        [height]="height"
        [image]="this.transmittedImage"
        [imageURL]="this.imageURL"
        (cropEvent)="this.saveCroppedImage($event)"
        (cancelEvent)="this.dialogClosed()"
      >
      </app-image-editor>
    </div>
    <div *ngIf="(this.transmittedImage || this.imageURL) && isCoverImage()">
      <app-image-editor
        [uploadTarget]="this.imageType"
        [width]="width"
        [height]="height"
        [image]="this.transmittedImage"
        [imageURL]="this.imageURL"
        [productCategory]="reformatProductCategory()"
        [productName]="this.productName"
        [startupName]="this.startupName"
        (cropEvent)="this.saveCroppedImage($event)"
        (cancelEvent)="this.dialogClosed()"
      >
      </app-image-editor>
    </div>
  </div>
  <div class="markant-dialog-footer"></div>
</markant-dialog>
